import { useQuery } from '@tanstack/react-query';
import {
  DIAM_API_PATH,
  DIAM_PAGE_LIMIT,
  diamQueryKeys,
  getTeamApplicationContextsPage,
} from '../../diamApi';
import { useApiEssentials } from '../../../../shared/hooks/useApiEssentials';

export function useTeamApplicationContexts(teamId: string | undefined) {
  const { getIdToken, apiUrl, isSignedIn } = useApiEssentials(DIAM_API_PATH);

  return useQuery({
    queryKey: diamQueryKeys.teamApplicationContexts(teamId ?? ''),
    queryFn: async () => {
      if (!teamId) {
        throw new Error('A team id is required');
      }

      const idToken = await getIdToken();
      return getTeamApplicationContextsPage(apiUrl, idToken, teamId, {
        page: 0,
        limit: DIAM_PAGE_LIMIT,
      });
    },
    enabled: isSignedIn && Boolean(teamId),
    retry: false,
    refetchOnWindowFocus: false,
  });
}
